import axios from "axios";
import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/image-template`;

const authHeaders = () => ({
  Authorization: `Bearer ${window.localStorage.getItem("token")}`,
});

class ImageTemplateServices {
  async getActiveYantras() {
    const action = `${API_ROUTE}/active-yantras`;
    return requestToken.get(action);
  }

  async getActiveList() {
    const action = `${API_ROUTE}/active-list`;
    return requestToken.get(action);
  }

  async getMyActiveImages(opts = {}) {
    const action = `${API_ROUTE}/my-active-images`;
    return requestToken.get(action, undefined, { signal: opts.signal });
  }

  async getActiveImagesForUser(targetUserId, opts = {}) {
    const action = `${API_ROUTE}/active-images-for-user/${targetUserId}`;
    return requestToken.get(action, undefined, { signal: opts.signal });
  }

  async getList({ page = 1, limit = 10, search = "" } = {}) {
    const params = new URLSearchParams();
    params.set("page", page);
    params.set("limit", limit);
    if (search) params.set("search", search);
    const action = `${API_ROUTE}/list?${params.toString()}`;
    return requestToken.get(action);
  }

  async getDetail(id) {
    const action = `${API_ROUTE}/detail/${id}`;
    return requestToken.get(action);
  }

  async createTemplate(formData) {
    const action = `${API_ROUTE}/create`;
    const res = await axios.post(action, formData, { headers: authHeaders() });
    return res.data;
  }

  async updateTemplate(id, formData) {
    const action = `${API_ROUTE}/update/${id}`;
    const res = await axios.put(action, formData, { headers: authHeaders() });
    return res.data;
  }

  async toggleActive(id, is_active) {
    const action = `${API_ROUTE}/toggle-active/${id}`;
    const res = await axios.patch(action, { is_active }, { headers: authHeaders() });
    return res.data;
  }
}

export default ImageTemplateServices;
